import React from 'react';
import PullImageNPM from '@rotaryintl/harris-pull-image';
import { Image } from '@sitecore-jss/sitecore-jss-react';

const PullImage = ({ fields: { Image: ImageField, Caption, Align, ClassName } = {} }) => {
  const align = Align?.value?.toLowerCase() || 'left';

  return <PullImageNPM image={ImageField ? <Image field={ImageField} /> : null} caption={Caption?.value} align={align} className={ClassName?.value} />;
};

export default PullImage;
